module.exports = __webpack_public_path__ + "static/media/desktop@2x.ac1e05ea.png";